const React = require("react");
const T = require("prop-types");
const IconButton = require("material-ui/IconButton").default;
const IconMenu = require("material-ui/IconMenu").default;
const MenuItem = require("material-ui/MenuItem").default;
const MoreVertIcon = require("material-ui/svg-icons/navigation/more-vert")
    .default;
const DownloadIcon = require("material-ui/svg-icons/file/file-download")
    .default;
const ShoppingCartIcon = require("material-ui/svg-icons/action/shopping-cart")
    .default;
const StarIcon = require("material-ui/svg-icons/action/grade").default;
const NavLink = require("react-router-dom").NavLink;
const Paper = require("material-ui/Paper").default;
const Classes = require("./styles.scss");
const { List, ListItem } = require("material-ui/List");
const Divider = require("material-ui/Divider").default;
const FlatButton = require("material-ui/FlatButton").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const DeleteConfirmDialog = require("components/Dialog/DeleteConfirmDialog");
const DownloadDialog = require("containers/DownloadDialog");
const TransactionDialog = require("containers/TransactionDialog");
const WhatsIncludedDialog = require("containers/WhatsIncludedDialog");

const internals = {};

internals.renderDate = dateString => {
    const date = new Date(dateString);

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    return month + "/" + day + "/" + year;
};

internals.menuItemStyle = {
    fontSize: "14px"
};

internals.buttonLabelStyle = {
    textTransform: "inherit"
};

internals.iconButtonElement = (
    <IconButton touch tooltip="Options" tooltipPosition="top-left">
        <MoreVertIcon />
    </IconButton>
);

module.exports = class Portfolio extends React.Component {
    static propTypes = {
        numCredits: T.number.isRequired,
        fetchPortfolioData: T.func.isRequired,
        croquisList: T.arrayOf(
            T.shape({
                id: T.number.isRequired,
                title: T.string.isRequired,
                dateCreated: T.string.isRequired,
                dateModified: T.string.isRequired
            })
        ).isRequired,
        purchasedList: T.arrayOf(
            T.shape({
                id: T.number.isRequired,
                title: T.string.isRequired,
                dateCreated: T.string.isRequired,
                downloadPackage: T.shape({
                    name: T.oneOf(["basic", "premium"]).isRequired
                }).isRequired
            })
        ).isRequired,
        deleteClick: T.func.isRequired,
        onDownloadOptionsClick: T.func.isRequired,
        onTransactionClick: T.func.isRequired,
        onSeeWhatsIncluded: T.func.isRequired
    };

    state = {
        isDeleteConfirmDialogOpen: false,
        croquisDeleteId: null
    };

    constructor(props, context) {
        super(props, context);

        this.renderedCroquisList = this._renderedCroquisList.bind(this);
        this.renderDownloadMenu = this._renderDownloadMenu.bind(this);
        this.renderedPurchasedList = this._renderedPurchasedList.bind(this);
    }

    componentDidMount() {
        this.props.fetchPortfolioData();
        window.scrollTo(0, 0);
    }

    handleOpenDeleteConfirmDialog = croquisDeleteId => {
        this.setState({
            isDeleteConfirmDialogOpen: true,
            croquisDeleteId
        });
    };

    handleCloseDeleteConfirmDialog = () => {
        this.setState({
            isDeleteConfirmDialogOpen: false,
            croquisDeleteId: null
        });
    };

    handleDelete = () => {
        const { deleteClick } = this.props;
        const { croquisDeleteId } = this.state;

        deleteClick(croquisDeleteId);
        this.handleCloseDeleteConfirmDialog();
    };

    _renderedCroquisList() {
        const { croquisList, onTransactionClick } = this.props;

        const listLength = croquisList.length;

        return (
            <Paper className={Classes.croquisList}>
                <div className={Classes.croquisListHeader}>
                    <h3>Saved Models</h3>
                </div>

                <div>
                    <p>
                        <NavLink
                            to="/instructions"
                            style={{ color: "#4BA6A0" }}
                        >
                            Create a new free preview,
                        </NavLink>{" "}
                        or choose one from below.
                    </p>
                </div>

                {listLength === 0 && <h4>You have no saved models.</h4>}

                {listLength > 0 && (
                    <List>
                        <Divider />
                        {croquisList.map(croquis => (
                            <div key={croquis.id}>
                                <ListItem
                                    disabled
                                    primaryText={
                                        <NavLink
                                            to={`/body-model/${croquis.id}`}
                                        >
                                            {croquis.title}
                                        </NavLink>
                                    }
                                    secondaryText={`Saved ${internals.renderDate(
                                        croquis.dateModified ||
                                            croquis.dateCreated
                                    )}`}
                                    className={Classes.croquisListItem}
                                    rightIconButton={
                                        <div>
                                            <RaisedButton
                                                primary
                                                label="Purchase"
                                                icon={<ShoppingCartIcon />}
                                                onClick={() =>
                                                    onTransactionClick(
                                                        "purchase",
                                                        croquis.id
                                                    )
                                                }
                                                className={
                                                    Classes.menuOptionsDesktop
                                                }
                                                labelStyle={
                                                    internals.buttonLabelStyle
                                                }
                                            />
                                            <IconMenu
                                                iconButtonElement={
                                                    internals.iconButtonElement
                                                }
                                            >
                                                <MenuItem
                                                    className={
                                                        Classes.menuOptionsMobile
                                                    }
                                                    onClick={() =>
                                                        onTransactionClick(
                                                            "purchase",
                                                            croquis.id
                                                        )
                                                    }
                                                    style={
                                                        internals.menuItemStyle
                                                    }
                                                >
                                                    <ShoppingCartIcon
                                                        style={{
                                                            verticalAlign:
                                                                "middle"
                                                        }}
                                                    />{" "}
                                                    Purchase
                                                </MenuItem>
                                                <MenuItem
                                                    containerElement={
                                                        <NavLink
                                                            to={`/body-model/${croquis.id}`}
                                                        />
                                                    }
                                                    style={
                                                        internals.menuItemStyle
                                                    }
                                                >
                                                    View
                                                </MenuItem>
                                                <MenuItem
                                                    containerElement={
                                                        <NavLink
                                                            to={`/body-model/${croquis.id}/edit`}
                                                        />
                                                    }
                                                    style={
                                                        internals.menuItemStyle
                                                    }
                                                >
                                                    Edit
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() =>
                                                        this.handleOpenDeleteConfirmDialog(
                                                            croquis.id
                                                        )
                                                    }
                                                    style={
                                                        internals.menuItemStyle
                                                    }
                                                >
                                                    Delete
                                                </MenuItem>
                                            </IconMenu>
                                        </div>
                                    }
                                />
                                <Divider />
                            </div>
                        ))}
                    </List>
                )}
            </Paper>
        );
    }

    _renderDownloadMenu(purchase) {
        const { onDownloadOptionsClick, onTransactionClick } = this.props;
        const { downloadPackage } = purchase;

        // TODO This if/else branching assumes only 2 download pacakges: basic and premium
        // This will fall down badly if we go to add more
        if (downloadPackage.name === "basic") {
            return (
                <div>
                    <IconMenu
                        className={Classes.menuOptionsMobile}
                        iconButtonElement={internals.iconButtonElement}
                    >
                        <MenuItem
                            style={internals.menuItemStyle}
                            onClick={() =>
                                onTransactionClick("upgrade", purchase.id)
                            }
                        >
                            <StarIcon style={{ verticalAlign: "middle" }} />{" "}
                            Upgrade to Premium (1 Credit)
                        </MenuItem>
                        <MenuItem
                            style={internals.menuItemStyle}
                            onClick={() => onDownloadOptionsClick(purchase.id)}
                        >
                            Download Basic
                        </MenuItem>
                        <MenuItem
                            containerElement={
                                <NavLink
                                    to={`/purchased-body-model/${purchase.id}`}
                                />
                            }
                            style={internals.menuItemStyle}
                        >
                            View
                        </MenuItem>
                    </IconMenu>
                    <div className={Classes.menuOptionsDesktop}>
                        <RaisedButton
                            primary
                            label={
                                <span>
                                    <StarIcon
                                        color="white"
                                        style={{
                                            position: "relative",
                                            top: ".6rem",
                                            right: ".5rem"
                                        }}
                                    />
                                    Upgrade to Premium (1 Credit)
                                </span>
                            }
                            onClick={() =>
                                onTransactionClick("upgrade", purchase.id)
                            }
                            labelStyle={internals.buttonLabelStyle}
                            style={{
                                lineHeight: "inherit",
                                marginRight: "20px"
                            }}
                        />
                        <RaisedButton
                            label="Download Basic"
                            icon={<DownloadIcon />}
                            labelStyle={internals.buttonLabelStyle}
                            onClick={() => onDownloadOptionsClick(purchase.id)}
                        />
                    </div>
                    <IconMenu
                        className={Classes.menuOptionsDesktop}
                        iconButtonElement={internals.iconButtonElement}
                    >
                        <MenuItem
                            containerElement={
                                <NavLink
                                    to={`/purchased-body-model/${purchase.id}`}
                                />
                            }
                            style={internals.menuItemStyle}
                        >
                            View
                        </MenuItem>
                    </IconMenu>
                </div>
            );
        }

        return (
            <div>
                <IconMenu
                    className={Classes.menuOptionsMobile}
                    iconButtonElement={internals.iconButtonElement}
                >
                    <MenuItem
                        style={internals.menuItemStyle}
                        onClick={() => onDownloadOptionsClick(purchase.id)}
                    >
                        Download Premium
                    </MenuItem>
                    <MenuItem
                        containerElement={
                            <NavLink
                                to={`/purchased-body-model/${purchase.id}`}
                            />
                        }
                        style={internals.menuItemStyle}
                    >
                        View
                    </MenuItem>
                </IconMenu>
                <div className={Classes.menuOptionsDesktop}>
                    <RaisedButton
                        label="Download Premium"
                        icon={<DownloadIcon />}
                        labelStyle={internals.buttonLabelStyle}
                        onClick={() => onDownloadOptionsClick(purchase.id)}
                    />
                </div>
                <IconMenu
                    className={Classes.menuOptionsDesktop}
                    iconButtonElement={internals.iconButtonElement}
                >
                    <MenuItem
                        containerElement={
                            <NavLink
                                to={`/purchased-body-model/${purchase.id}`}
                            />
                        }
                        style={internals.menuItemStyle}
                    >
                        View
                    </MenuItem>
                </IconMenu>
            </div>
        );
    }

    _renderedPurchasedList() {
        const { purchasedList, onSeeWhatsIncluded } = this.props;

        return (
            <Paper className={Classes.croquisList}>
                <div className={Classes.croquisListHeader}>
                    <h3>Purchased Files</h3>
                    {/* <FlatButton
                        primary
                        label='Add Download Credits'
                        labelStyle={internals.buttonLabelStyle}
                        onClick={() => onTransactionClick('credits')}
                        className='add_credits'
                    /> */}
                </div>

                <div>
                    <p>
                        A digital &amp; printable fashion sketchbook of YOUR
                        body.{" "}
                        <FlatButton
                            primary
                            label="See what's included."
                            labelStyle={internals.buttonLabelStyle}
                            onClick={onSeeWhatsIncluded}
                            className="whats-included"
                        />
                    </p>
                </div>

                {this.props.purchasedList.length === 0 && (
                    <h4>You have no files available to download.</h4>
                )}

                {this.props.purchasedList.length > 0 && (
                    <List>
                        <Divider />
                        {purchasedList.map(purchase => {
                            return (
                                <div key={purchase.id}>
                                    <ListItem
                                        disabled
                                        primaryText={
                                            <div
                                                className={
                                                    Classes.listItemTitle
                                                }
                                            >
                                                <NavLink
                                                    to={`/purchased-body-model/${purchase.id}`}
                                                >
                                                    {purchase.title}
                                                </NavLink>
                                            </div>
                                        }
                                        secondaryText={`Created ${internals.renderDate(
                                            purchase.dateCreated
                                        )}`}
                                        className={Classes.croquisListItem}
                                        leftIcon={
                                            purchase.downloadPackage.name ===
                                            "premium" ? (
                                                <StarIcon />
                                            ) : (
                                                undefined
                                            )
                                        }
                                        rightIconButton={this.renderDownloadMenu(
                                            purchase
                                        )}
                                    />
                                    <Divider />
                                </div>
                            );
                        })}
                    </List>
                )}
            </Paper>
        );
    }

    render() {
        const { croquisList, numCredits, onTransactionClick } = this.props;

        const { isDeleteConfirmDialogOpen, croquisDeleteId } = this.state;

        const renderedCroquisList = this.renderedCroquisList();
        const renderedPurchasedList = this.renderedPurchasedList();

        return (
            <div>
                <h1>Welcome to your portfolio</h1>
                {/* <p>
          Get started by{" "}
          <NavLink to="/instructions">creating a new body model</NavLink>, or
          choose one from your portfolio.
        </p> */}
                <p>
                    Bookmark this page for easy access to your Purchased Files
                    and Saved Models.
                </p>
                <div className={Classes.topButtonsContainer}>
                    <div className={Classes.mainButtonsContainer}>
                        <RaisedButton
                            primary
                            label="Buy Credits"
                            labelStyle={internals.buttonLabelStyle}
                            onClick={() => onTransactionClick("credits")}
                            className="add_credits"
                        />
                        <RaisedButton
                            secondary
                            label="New Preview"
                            labelStyle={internals.buttonLabelStyle}
                            containerElement={<NavLink to="/instructions" />}
                        />
                    </div>
                    <Paper className={Classes.creditsBanner}>
                        <p>{numCredits} Credit(s) remaining</p>
                    </Paper>
                </div>
                {renderedPurchasedList}
                {renderedCroquisList}
                <DeleteConfirmDialog
                    dialogOpen={isDeleteConfirmDialogOpen}
                    dialogClose={this.handleCloseDeleteConfirmDialog}
                    onDelete={this.handleDelete}
                    croquis={croquisList.find(c => c.id === croquisDeleteId)}
                />
                <DownloadDialog
                    onUpgradeClick={modelId =>
                        onTransactionClick("upgrade", modelId)
                    }
                />
                <TransactionDialog />
                <WhatsIncludedDialog />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/portfolio/components/Portfolio.js